import { useEffect } from "react";
import { useAddSpaceGroupMemberModal } from "@circle-react/components/Modals/AddSpaceGroupMember";
import type { SpaceGroup } from "@circle-react/types";
import { ShowSpaceGroup } from "../Show";

export interface InviteMemberProps {
  spaceGroup: SpaceGroup;
}

export const InviteMember = ({ spaceGroup }: InviteMemberProps) => {
  const addSpaceGroupMemberModal = useAddSpaceGroupMemberModal();

  useEffect(() => {
    void addSpaceGroupMemberModal.show({ spaceGroupId: spaceGroup?.id || 0 });
  }, []);

  return <ShowSpaceGroup spaceGroup={spaceGroup} />;
};
